import React from "react"
import ReactApexChart from "react-apexcharts"

const StackedBarGraph = ({
	data,
	series1Name,
	series2Name,
	series3Name = null,
	series4Name = null,
	series5Name = null,
	xAxisKey,
	xAxisLabel,
	yAxisLabel,
	height = 350,
	colors = ["#352D66", "#6955EA", "#f87171"], // Using your existing color scheme
	showLegend = false,
	legendItems = []
}) => {
	const options = {
		chart: {
			type: "bar",
			height: height,
			stacked: true,
			toolbar: {
				show: false
			},
			fontFamily: "Manrope, sans-serif"
		},
		plotOptions: {
			bar: {
				horizontal: false,
				columnWidth: "50%",
				borderRadius: 3,
				borderRadiusApplication: "end",
				borderRadiusWhenStacked: "last"
			}
		},
		legend: {
			show: showLegend,
			position: "bottom",
			horizontalAlign: "center",
			fontSize: "12px",
			markers: {
				width: 12,
				height: 12,
				radius: 2
			},
			itemMargin: {
				horizontal: 10,
				vertical: 5
			},
			onItemClick: {
				toggleDataSeries: false
			},
			onItemHover: {
				highlightDataSeries: false
			}
		},
		dataLabels: {
			enabled: false
		},
		stroke: {
			width: 0,
			colors: ["#fff"]
		},
		xaxis: {
			categories: data.map(item => item[xAxisKey]),
			labels: {
				style: {
					fontSize: "12px",
					colors: ["#8c8c8c"]
				}
			},
			title: {
				text: xAxisLabel,
				style: {
					fontSize: "12px",
					color: "#8c8c8c"
				}
			}
		},
		yaxis: {
			title: {
				text: yAxisLabel,
				style: {
					fontSize: "12px",
					color: "#8c8c8c"
				}
			},
			labels: {
				style: {
					fontSize: "12px",
					colors: ["#8c8c8c"]
				}
			}
		},
		colors: colors,
		grid: {
			borderColor: "#f1f1f1"
		},
		tooltip: {
			y: {
				formatter: function (val) {
					return val
				}
			}
		},
		fill: {
			opacity: 1,
			type: "solid"
		}
	}

	const series = [
		{
			name: legendItems.length > 0 ? legendItems[0].label : series1Name.name,
			data: data.map(item => item[series1Name.key])
		},
		{
			name: legendItems.length > 0 ? legendItems[1].label : series2Name.name,
			data: data.map(item => item[series2Name.key])
		}
	]

	// Add third series if series3Name is provided
	if (series3Name) {
		series.push({
			name: legendItems.length > 0 ? legendItems[2].label : series3Name.name,
			data: data.map(item => item[series3Name.key])
		})
	}

	// Add fourth series if series4Name is provided
	if (series4Name) {
		series.push({
			name: legendItems.length > 0 ? legendItems[3].label : series4Name.name,
			data: data.map(item => item[series4Name.key])
		})
	}

	// Add fifth series if series5Name is provided
	if (series5Name) {
		series.push({
			name: legendItems.length > 0 ? legendItems[4].label : series5Name.name,
			data: data.map(item => item[series5Name.key])
		})
	}

	return (
		<>
			<div className="">
				<ReactApexChart options={options} series={series} type="bar" height={height} />
			</div>
		</>
	)
}

export default StackedBarGraph
